<template>
  <span v-if="workingQualifier">
      <v-row class="mt-8">
          <v-col cols="12">
            <v-text-field
              label="Minimum Transaction Count"
              v-model="workingQualifier.minimumTransactionCount"
              type="number"
              hint="Ex. 2"
              hide-spin-buttons
              dense
              :rules="requiredAndPositiveRule"
              @input="onChange"
              name="minimumTransactionCount"
            />
          </v-col>
        </v-row>
        <v-row class="mt-6">
          <v-col cols="12">
            <v-text-field
              label="Minimum Transaction Amount"
              v-model="workingQualifier.minimumTransactionAmount"
              type="number"
              hint="Ex. 5.00"
              prefix="$"
              hide-spin-buttons
              dense
              :rules="requiredAndPositiveRule"
              @input="onChange"
              name="minimumTransactionAmount"
            />
          </v-col>
        </v-row>
        <v-row class="mt-6">
          <v-col cols="12">
            <v-radio-group
              label="POS Transaction Type"
              v-model="workingQualifier.transactionType"
              dense
              :rules="requiredRule"
              ref="transactionType"
              @change="onChange">
                <v-radio v-for="item in Object.entries(CreditOrDebitPosTransactionTypes)" v-bind:key="item.value" :value="item[1].value" :label="item[1].description" :ref="`${item[1].value}_Radio`"/>
            </v-radio-group>
          </v-col>
        </v-row>
    </span>
</template>

<script lang="ts">
import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { CreditOrDebitCardQualifier, CreditOrDebitPosTransactionTypes } from '@/api/product/levelrewards/qualifiers';
import { ValidationTool } from '@/util';

@Component
export default class CreditOrDebitCardQualifierEditor extends Vue {
  @Prop()
  value!:CreditOrDebitCardQualifier;

  workingQualifier:CreditOrDebitCardQualifier | null = null;

  // Make visible to template
  CreditOrDebitPosTransactionTypes:any = CreditOrDebitPosTransactionTypes;

  requiredRule:Array<any> = [(value: any) => {
    if (value === null || value === undefined || (Array.isArray(value) && value.length === 0)) {
      return 'Required';
    }
    return true;
  }];

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  mounted() {
    this.initialize();
  }

  @Watch('value')
  initialize() {
    this.workingQualifier = this.value.clone() as CreditOrDebitCardQualifier;
  }

  onChange() {
    this.$emit('input', this.workingQualifier);
  }
}
</script>

<style lang="scss" scoped>
</style>
